import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-inline-wrapper',
  templateUrl: './inline-wrapper.component.html',
  styleUrl: './inline-wrapper.component.scss',
})
export class FormlyInlineWrapperComponent extends FieldWrapper {}
